import { Badge } from '@highlight-cp/core-ui';
import type { BadgeProps } from '@highlight-cp/core-ui';

export type BetaBadgeProps = Omit<
  BadgeProps,
  | 'bg'
  | 'children'
  | 'color'
  | 'fullWidth'
  | 'leftSection'
  | 'rightSection'
  | 'radius'
  | 'size'
  | 'variant'
>;

/**
 * ### BetaBadge
 *
 * @description
 * A badge component displaying "BETA" with a yellow fill, lighter yellow inset, and black label.
 * The inset ring is the theme's `beta` Badge variant, so the locked core-ui `Badge` is enough —
 * no `classNames` needed here.
 *
 * @example
 * <BetaBadge />
 *
 * @returns React component
 */
export const BetaBadge = (props: BetaBadgeProps) => (
  <Badge {...props} radius="xl" variant="beta">
    BETA
  </Badge>
);
